<p [innerHtml]="message| markedInline"></p>
<a *ngIf="getShowLink()" [FCRouterLink]="getAdvertiserDisclosure()" id="fc-advertiser-disclosure" [target]="target">{{linkMessage}}</a>
<p *ngIf="!showLink && scrollLocation" (click)="scrollTo()" style="text-decoration: underline; cursor: pointer;">{{linkMessage}}</p>